angular.module('bmsApp.settings')
	.factory('OnlineDiscountSvc', function ($http, $log, $window, $q, CRUDSvc) {

		return {
			index: function (params) {
				return CRUDSvc.get('api/settings/online-discount/index', params);
			},
			save: function (data) {
				return CRUDSvc.post('api/settings/online-discount/save', data);
			},
			options: function (params) {
				return CRUDSvc.get('api/settings/online-discount/options', params);
			},
			emailRedemptionCode: function (licenseId) {
				return CRUDSvc.get('api/settings/online-discount/email-redemption-code/' + licenseId);
			},
			setAsEmailRedemptionCode: function(params){
				return CRUDSvc.post('api/settings/online-discount/set-as-email-redemption-code', params);
			}
		}
	});



